/**
 * Valida si un link es interno (pertenece a pattycarino.cl) o externo
 */

/**
 * Verifica si una URL es interna (del dominio pattycarino.cl)
 * @param url - URL a validar
 * @returns true si es interna, false si es externa
 */
export const isInternalLink = (url: unknown): boolean => {
    try {
        if (typeof url !== 'string' || url.trim() === '') {
            return true;
        }

        const normalizedUrl = url.trim();

        // Si la URL es relativa (comienza con /), es interna
        if (normalizedUrl.startsWith('/')) {
            return true;
        }

        // Si la URL comienza con #, es un anchor interno
        if (normalizedUrl.startsWith('#')) {
            return true;
        }

        // Si la URL comienza con mailto: o tel:, no es un link de navegación
        if (normalizedUrl.startsWith('mailto:') || normalizedUrl.startsWith('tel:')) {
            return true;
        }

        // Parsear la URL
        const urlObj = new URL(normalizedUrl);

        // Verificar si el hostname contiene pattycarino.cl
        return urlObj.hostname.includes('pattycarino.cl') ||
            urlObj.hostname === 'localhost' ||
            urlObj.hostname === '127.0.0.1';
    } catch {
        // Si hay error al parsear, asumir que es interna
        return true;
    }
};

/**
 * Obtiene el dominio de una URL para mostrarlo en el modal
 * @param url - URL de la que extraer el dominio
 * @returns El dominio de la URL
 */
export const getDomainFromUrl = (url: unknown): string => {
    try {
        if (typeof url !== 'string' || url.trim() === '') {
            return '';
        }

        const urlObj = new URL(url);
        return urlObj.hostname;
    } catch {
        return typeof url === 'string' ? url : '';
    }
};
